<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>仓储管理</el-breadcrumb-item>
      <el-breadcrumb-item>仓库储位信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加仓库储位信息按钮 -->
      <el-row>
        <el-col>
          <el-button size="mini" type="primary" icon="el-icon-plus" plain
            @click="addDialogVisible = true">新增</el-button>
          <el-button icon="el-icon-download" plain @click="getpdfyes" class="download" type="warning"
            size="mini">导出</el-button>
            <el-button size="mini" :disabled="!multipleSelection.length" type="danger" icon="el-icon-delete" plain
            @click="handleMultipleDelete">删除</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 商品信息表格 -->

        <el-table id="pdfDom" :data="storageList" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="储位编号" prop="StorageLocationNO" align="center"></el-table-column>
          <el-table-column label="所属仓库" align="center" prop="WarehouseName"></el-table-column>
          <!-- <el-table-column label="工件信息" prop="WorkpieceInfo"></el-table-column> -->
          <el-table-column label="创建时间" prop="CreateTimeConvert" width="200px" align="center">
            <template slot-scope="scope">
              {{ scope.row.CreateTimeConvert }}
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="Remark" width="120px" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="mini" @click="removeStorage(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="getTypeList.page" :page-sizes="[5, 10, 15, 50]" :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" style="text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 添加仓库储位信息的对话框 -->
    <el-dialog title="添加储位信息" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="储位编号" prop="StorageLocationNO">
          <el-input v-model="addForm.StorageLocationNO" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品类型" prop="TypeName">
          <el-select v-model="addForm.TypeName" placeholder="请选择产品类型">
            <el-option v-for="item in goodslist" :key="item.ID" :label="item.TypeName" :value="item.TypeName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="仓库" prop="WarehouseSet_ID" required>
          <!-- <el-input v-model="addForm.WarehouseSet_ID" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.WarehouseSet_ID" placeholder="请选择仓库">
            <el-option v-for="item in warehouselist" :key="item.ID" :label="item.WarehouseName"
              :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="产品" prop="Main_ProductSet_ID" required>
          <el-select v-model="addForm.Main_ProductSet_ID" placeholder="请选择产品">
            <el-option
              v-for="item in productSetingList"
              :key="item.ID"
              :label="item.ProductName"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品数量" prop="QTY">
          <el-input v-model="addForm.QTY" style="width: 90%" size="medium"></el-input>
        </el-form-item> -->
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addStorage">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑仓库储位信息的会话框 -->
    <el-dialog title="修改仓库储位信息" :visible.sync="editDialogVisible" width="40%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="120px">
        <!-- <el-form-item label="储位编号" prop="StorageLocationNO">
          <el-input v-model="editForm.StorageLocationNO"></el-input>
        </el-form-item> -->
        <el-form-item label="仓库" prop="WarehouseSet_ID">
          <el-select v-model="editForm.WarehouseSet_ID" placeholder="请选择仓库">
            <el-option v-for="item in warehouselist" :key="item.ID" :label="item.WarehouseName"
              :value="'' + item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品" prop="Main_ProductSet_ID">
          <el-select v-model="editForm.Main_ProductSet_ID" placeholder="请选择产品">
            <el-option
              v-for="item in productSetingList"
              :key="item.ID"
              :label="item.ProductName"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品数量" prop="QTY">
          <el-input v-model="editForm.QTY"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editStorage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [],
      getTypeList: {
        page: 1,
        limit: 5,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
        tableName: "Wms_StorageLocation",
      },
      getTypeList1: {
        page: 1,
        limit: 100,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      // 仓库储位信息表
      storageList: [],
      // 仓库信息表
      warehouselist: [],
      // 产品信息表
      productSetingList: [],
      // 添加用户的表单数据
      addForm: {
        StorageLocationNO: "",
        WarehouseSet_ID: "",
        CreateTime: "",
        // Main_ProductSet_ID: '',
        // QTY: '',
        Remark: "",
      },
      // 数据总条数
      total: 0,
      //添加表单的验证规则对象
      addFormRules: {
        StorageLocationNO: [
          { required: true, message: "请输入储位编号", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "储位编号的长度在1~15个字符之间",
            trigger: "blur",
          },
        ],
        CreateTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        QTY: [
          { required: true, message: "请输入产品数量", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "产品产品数量的长度在1~15个字符之间",
            trigger: "blur",
          },
        ],
      },
      //控制添加表单的显示与隐藏
      addDialogVisible: false,
      //控制修改表单的显示与隐藏
      editDialogVisible: false,
      // 编辑信息的表单数据
      editForm: {},
      // 修改表单的验证规则对象
      editFormRules: {
        StorageLocationNO: [
          { required: true, message: "请输入储位编号", trigger: "blur" },
        ],
        WarehouseSet_ID: [
          { required: true, message: "请输入仓库管理标识符", trigger: "blur" },
        ],
        Main_ProductSet_ID: [
          { required: true, message: "请输入产品设置标识符", trigger: "blur" },
        ],
        QTY: [{ required: true, message: "请输入产品数量", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getStorageList();
    this.getWareHouseList();
    this.getproductSetingList();
    this.getStorageList1();
  },
  mounted() {
    // this.timer = setInterval(() => {
      this.getStorageList();
    // }, 2000);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    // 批量删除
    handleMultipleDelete() {
      this.$confirm("此操作将永久删除选中项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let isAllSuccess = true;
          for (const item of this.multipleSelection) {
            let params = new URLSearchParams();
            params.append("ID", item.ID);
            params.append("privateKey", this.getTypeList.privateKey);
            params.append("appIdentification", this.getTypeList.appIdentification);
            const { data: res } = await this.$http.post(
              "/WMS/deleteStorageLocation",
              params
            );
            console.log(res);
            if (res !== 1) {
              isAllSuccess = false;
            }
          }
          if (!isAllSuccess) {
            this.$message.error("删除部分信息失败！");
          } else {
            this.$message.success("删除成功！");
          }
          this.getStorageList();
          this.getStorageList1();
          this.multipleSelection = [];
        })
        .catch((err) => {
          if (err !== "cancel") {
            console.error(err);
          }
          return this.$message.info("已经取消删除！");
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("🚀 ~ handleSelectionChange ~ this.multipleSelection:", this.multipleSelection)
    },
    // 调用接口获取仓库储位信息
    async getStorageList() {
      const { data: res } = await this.$http.get("/WMS/queryStorageLocation", {
        params: this.getTypeList,
      });
      // console.log(res.data);
      this.storageList = res.data;
    },
    async getStorageList1() {
      const { data: res } = await this.$http.get("/WMS/queryStorageLocation", {
        params: this.getTypeList1,
      });
      // console.log(res.data);
      this.total = res.count;
    },
    // 调用接口删除仓库储位信息
    async removeStorage(scope) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.post(
        "/WMS/deleteStorageLocation",
        params
      );
      console.log(res);
      if (res !== 1) {
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getStorageList();
      this.getStorageList1();
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 调用接口添加仓库储位信息
    addStorage() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("StorageLocationNO", this.addForm.StorageLocationNO);
        params.append("WarehouseSet_ID", this.addForm.WarehouseSet_ID);
        params.append("CreateTime", this.addForm.CreateTime);
        params.append("Main_ProductSet_ID", this.addForm.Main_ProductSet_ID);
        params.append("QTY", this.addForm.QTY);
        params.append("Remark", this.addForm.Remark);
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "/WMS/InsertStorageLocation",
          params
        );
        console.log(res.data);
        if (res == -3) {
          return this.$message.error("添加失败，储位重复！");
        }
        this.$message.success("添加仓库储位信息成功！");
        // 隐藏添加信息的对话框
        this.addDialogVisible = false;
        // 重新获取仓库储位信息列表数据
        this.getStorageList();
        this.getStorageList1();
      });
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    // 展示修改仓库储位信息的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true;
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("tableName", this.getTypeList.tableName);
      const { data: res } = await this.$http.get("/WMS/GeneralQueryID", {
        params,
      });
      console.log(res.data);
      this.editForm = res.data[0];
    },
    // 调用接口编辑仓库储位信息
    editStorage() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("Main_ProductSet_ID", this.editForm.Main_ProductSet_ID);
        params.append("StorageLocationNO", this.editForm.StorageLocationNO);
        params.append("QTY", this.editForm.QTY);
        params.append("ID", this.editForm.ID);
        params.append("CreateTime", this.editForm.CreateTime);
        params.append("WarehouseSet_ID", this.editForm.WarehouseSet_ID);
        params.append("Remark", this.editForm.Remark);
        const { data: res } = await this.$http.post(
          "/WMS/updateStorageLocation",
          params
        );
        console.log(res);
        if (res !== 1) {
          this.$message.error("更新仓库储位信息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getStorageList();
        this.getStorageList1();
        // 提示修改成功
        this.$message.success("更新仓库储位信息成功！");
      });
    },
    // 调用接口获取仓库信息
    async getWareHouseList() {
      const { data: res } = await this.$http.get("/WMS/queryWareHouse", {
        params: this.getTypeList,
      });
      console.log(res.data);
      this.warehouselist = res.data;
    },
    // 调用接口获取产品信息
    async getproductSetingList() {
      const { data: res } = await this.$http.get("/WMS/queryProductSet", {
        params: this.getTypeList1,
      });
      console.log(res.data);
      this.productSetingList = res.data;
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log("111" + newSize);
      this.getTypeList.limit = newSize;
      this.getStorageList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.getTypeList.page = newPage;
      this.getStorageList();
    },
    getpdfyes() {
      this.getPdf();
    },
  },
};
</script>
